import * as api from "@/api";
import { BingWallpaperResponse } from "@/types";
import { useQuery } from "@tanstack/react-query";

interface BingWallpaperInfo {
	bingWallpaperCopyright?: string;
	bingWallpaperDescription?: string;
	bingWallpaperResponse?: BingWallpaperResponse;
	bingWallpaperTitle?: string;
	bingWallpaperUrl?: string;
	bingWallpaperUrlUhd?: string;
}

function useBingWallpaper(): BingWallpaperInfo {
	const { data } = useQuery({
		queryFn: api.getBingWallpaperInfo,
		queryKey: ["bingWallpaperInfo"],
		refetchOnMount: false,
		refetchOnWindowFocus: false,
	});

	const parseBingWallpaperData = (
		data?: BingWallpaperResponse | null,
	): BingWallpaperInfo => {
		if (!data) {
			return {};
		}
		const bingWallpaper = data?.info?.images?.[0];
		if (!bingWallpaper?.url) {
			return {};
		}
		const copyrightSymbol = "© ";
		const copyrightSeparator = " (" + copyrightSymbol;
		const copyright =
			copyrightSymbol +
			bingWallpaper?.copyright
				.split(copyrightSeparator)[1]
				.slice(0, -1) // delete the right parenthesis
				.replace(/\//g, " / ");
		const url = "https://cn.bing.com" + bingWallpaper.url;
		return {
			bingWallpaperCopyright: copyright,
			bingWallpaperDescription:
				bingWallpaper?.copyright.split(copyrightSeparator)[0],
			bingWallpaperResponse: data,
			bingWallpaperTitle: bingWallpaper?.title,
			bingWallpaperUrl: url,
			bingWallpaperUrlUhd: url?.replace("1920x1080", "UHD"),
		};
	};

	return parseBingWallpaperData(data);
}

export default useBingWallpaper;
